"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isScopedBinding = isScopedBinding;
function isScopedBinding(binding) {
    return (binding.scope !==
        undefined);
}
//# sourceMappingURL=isScopedBinding.js.map